// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"714":"9b511b79","986":"ecb5f7a8"}[chunkId] + ".chunk.js";
};